export default {"src":"/_next/static/media/ra-aircraft-capacity.11e70e77.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};